/* eslint-disable react/button-has-type */
import React from 'react';
import classNames from 'classnames';
import './Button.scss';

interface ButtonProps {
  width?: number | string;
  height?: number | string;
  label: string | React.ReactNode;
  color: 'primary' | 'secondary' | 'primary-invert';
  type: 'submit' | 'button' | 'reset';
  className?: string;
  onClick?: Function;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({ width, height, label, color, type, className, onClick, disabled }) => {
  const handleClickButton = () => {
    onClick && onClick();
  };
  return (
    <button
      className={classNames(`Button ${className} ${color}`, { disabled })}
      type={type}
      style={{ width, height }}
      onClick={handleClickButton}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default Button;
